import { motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import { IMAGES, CONTACT, openChat } from "@/config/site";
import { Counter } from "./Motion";
import { WhatsAppIcon } from "./WhatsAppIcon";

const STATS = [
  { to: 16, suffix: "+", label: "Years Experience", id: "years" },
  { to: 10000, suffix: "+", label: "Happy Customers", id: "customers" },
  { to: 40, suffix: "+", label: "Brands", id: "brands" },
];

const fade = (d) => ({ initial: { opacity: 0, y: 30 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.8, delay: d, ease: [0.22, 1, 0.36, 1] } });

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative flex min-h-[100svh] items-end lg:items-center overflow-hidden">
    <motion.img
      src={IMAGES.hero}
      alt="Indian house rooftop with solar panels"
      initial={{ scale: 1.12 }}
      animate={{ scale: 1 }}
      transition={{ duration: 2.4, ease: "easeOut" }}
      className="absolute inset-0 h-full w-full object-cover object-[65%_center]"
    />
    <div className="absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-navy-950/55 to-transparent" />
    <div className="absolute inset-0 hidden lg:block bg-[linear-gradient(90deg,rgba(5,10,28,0.78)_0%,rgba(5,10,28,0.5)_32%,rgba(5,10,28,0)_58%)]" />
    <div className="absolute inset-x-0 bottom-0 hidden lg:block h-48 bg-gradient-to-t from-navy-950/45 to-transparent" />
    <div className="absolute inset-0 lg:hidden bg-gradient-to-t from-navy-950/95 via-navy-950/55 via-55% to-transparent" />

    <div className="relative container-x w-full pt-32 pb-16 lg:py-36">
      <div className="max-w-3xl">
        <motion.h1 {...fade(0.2)} data-testid="hero-headline" className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.15] text-white drop-shadow-[0_2px_12px_rgba(0,0,0,0.35)]">
          सोलर लगवाएं,
          <br />
          <span className="text-gold-bright">बिजली बिल बचाएं</span>
        </motion.h1>
        <motion.p {...fade(0.35)} className="mt-5 max-w-xl text-lg sm:text-xl font-medium text-white/90">
          Homes, shops, schools & factories — one trusted name.
        </motion.p>
        <motion.div {...fade(0.5)} className="mt-8 flex flex-col sm:flex-row gap-3">
          <button onClick={openChat} data-testid="hero-free-visit-button" className="btn-gold h-14 px-8 text-lg">
            <CalendarCheck className="h-5 w-5" /> Book Free Site Visit
          </button>
          <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-button" className="btn-wa h-14 px-8 text-lg">
            <WhatsAppIcon className="h-5 w-5" /> WhatsApp करें
          </a>
        </motion.div>
        <motion.div {...fade(0.65)} className="mt-10 grid grid-cols-3 divide-x divide-white/15 rounded-2xl border border-white/15 bg-navy-950/45 backdrop-blur-xl" data-testid="hero-trust-stats">
          {STATS.map((s) => (
            <div key={s.id} className="px-3 py-4 sm:px-6 sm:py-5">
              <div className="font-display text-2xl sm:text-4xl font-extrabold text-gold-light">
                <Counter to={s.to} suffix={s.suffix} testId={`hero-stat-${s.id}`} />
              </div>
              <div className="mt-1 text-sm sm:text-base text-white/85">{s.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
